export const MODAL = {
  UNSUPPORTED: {
    BODY: 'Solo se permite cargar imágenes de tipo PNG, JPG o JPEG.',
    TITLE: 'Tipo de imagen no permitido',
    BUTTON_LABEL: 'Entendido',
  },
}
